import React from "react"

import { FORMAT_ELEMENT_COMMAND } from "lexical"
import { CenterAlign, LeftAlign, RightAlign } from "@editor/theme/editorIcons"

import { Button, Tooltip } from "@dit/core-frontend"

export const BlockChangeAlign = ({ activeEditor, isEditable, buttonProps }) => {
  return (
    <>
      <Tooltip content="Выравнивание по левому краю">
        <Button
          {...buttonProps}
          kind="borderless"
          disabled={!isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(FORMAT_ELEMENT_COMMAND, "left")
          }}
        >
          <LeftAlign />
        </Button>
      </Tooltip>
      <Tooltip content="Выравнивание по центру">
        <Button
          {...buttonProps}
          kind="borderless"
          disabled={!isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(FORMAT_ELEMENT_COMMAND, "center")
          }}
        >
          <CenterAlign />
        </Button>
      </Tooltip>
      <Tooltip content="Выравнивание по правому краю">
        <Button
          {...buttonProps}
          kind="borderless"
          disabled={!isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(FORMAT_ELEMENT_COMMAND, "right")
          }}
        >
          <RightAlign />
        </Button>
      </Tooltip>
    </>
  )
}
